import React from 'react';
import Icon from '../../../components/AppIcon';

const WalletStats = ({ credentials }) => {
  const totalCredentials = credentials?.length;
  const verifiedCredentials = credentials?.filter(c => c?.status === 'verified')?.length;
  const expiredCredentials = credentials?.filter(c => c?.status === 'expired')?.length;
  const expiringCredentials = credentials?.filter(c => {
    if (!c?.expirationDate || c?.status === 'expired') return false;
    const expirationDate = new Date(c.expirationDate);
    const thirtyDaysFromNow = new Date();
    thirtyDaysFromNow?.setDate(thirtyDaysFromNow?.getDate() + 30);
    return expirationDate <= thirtyDaysFromNow;
  })?.length;

  const blockchainVerified = credentials?.filter(c => c?.blockchainVerified)?.length;

  const stats = [
    {
      label: 'Total Credentials',
      value: totalCredentials,
      icon: 'FileText',
      color: 'text-primary bg-primary/10'
    },
    {
      label: 'Verified',
      value: verifiedCredentials,
      icon: 'CheckCircle',
      color: 'text-success bg-success/10'
    },
    {
      label: 'Expiring Soon',
      value: expiringCredentials,
      icon: 'Clock',
      color: 'text-warning bg-warning/10'
    },
    {
      label: 'Expired',
      value: expiredCredentials,
      icon: 'AlertTriangle',
      color: 'text-error bg-error/10'
    },
    {
      label: 'Blockchain Verified',
      value: blockchainVerified,
      icon: 'Link',
      color: 'text-accent bg-accent/10'
    }
  ];

  return (
    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4 mb-6">
      {stats?.map((stat, index) => (
        <div key={index} className="bg-card border border-border rounded-lg p-4">
          <div className="flex items-center space-x-3">
            <div className={`w-10 h-10 rounded-lg flex items-center justify-center ${stat?.color}`}>
              <Icon name={stat?.icon} size={20} />
            </div>
            <div>
              <p className="text-2xl font-bold text-foreground">{stat?.value}</p>
              <p className="text-sm text-muted-foreground">{stat?.label}</p>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default WalletStats;